export const parseSvgString = (pinSvgString: string) => {
  const parser = new DOMParser()
  return parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement
}
